import axios from "axios";
import { useMutation } from "react-query";
import { END_POINT } from "config/environment";
import { ICampaignPayload } from "../types";

export const updateCampaign = async (props: ICampaignPayload) => {
  const url = `${END_POINT.BASE_URL}/v1/administrator/campaigns/${props.id}`;
  const { token, id, ...body } = props;
  return axios.put(url, body, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const useUpdateCampaign = () => useMutation(updateCampaign);
